export const socialMediaLinks = {
  linkdin: "https://linkedin.com/company/certbar",
  instagram: "https://www.instagram.com/certbar/",
  twitter: "https://twitter.com/certbar",
  facebook: "https://www.facebook.com/certbar",
};
